/*
**********************************************************************************************
this is added to the _BasicWithMetricsLayout.cshtml & _AccountLayout2.cshtml files
**********************************************************************************************
*/

async function init() {
    if(document.getElementById("needsRecaptcha")){
        const { default: recaptcha } = await import('../../thirdparty/recaptcha/recaptchascript.js');
        recaptcha.init();
    }
}

await init();